import React from 'react';
import { useTransition, animated } from '@react-spring/web';
import PropTypes from 'prop-types';
import './RoundUpStyles.scss';

import IntroSlide from './slides/IntroSlide/IntroSlide';
import BandRoleSlide from './slides/BandRoleSlide/BandRoleSlide';
import ImageSlide from './slides/ImageSlide/ImageSlide';
import ConcertAttendanceSlide from './slides/ConcertAttendanceSlide/ConcertAttendanceSlide';
import SongSlide from './slides/SongSlide/SongSlide';
import RecentSkillsSlide from './slides/SkillsListedSlides/RecentSkillsSlide';
import SkillsInProgressSlide from './slides/SkillsListedSlides/SkillsInProgressSlide';
import UpcomingSkillsSlide from './slides/SkillsListedSlides/UpcomingSkillsSlide';
import SkillsTotalSlide from './slides/TotalSkillsSlide/TotalSkillsSlide';
import TrinityGradeSlide from './slides/TrinitySlides/TrinityGradeSlide';
import TrinityProgressSlide from './slides/TrinitySlides/TrinityProgressSlide';
import UpcomingConcertSlide from './slides/UpcomingConcertSlide/UpcomingConcertSlide';
import OutroPosterSlide from './slides/OutroPosterSlide/OutroPosterSlide';

const getSlideComponent = (slide, props) => {
  const { name, dataPoints, colorOption } = slide;
  const { kidId, grownUpId, startFunc, triggerAudioTrackPause, triggerClose, isAndroid } = props;

  switch (name) {
    case 'intro':
      return <IntroSlide data={dataPoints} startFunc={startFunc} />;
    case 'band_role':
      return <BandRoleSlide data={dataPoints} />;
    case 'media':
      return (
        <ImageSlide
          data={dataPoints}
          kidId={kidId}
          grownUpId={grownUpId}
          colorOption={colorOption}
          isAndroid={isAndroid}
        />
      );
    case 'concert_attendance':
      return <ConcertAttendanceSlide data={dataPoints} />;
    case 'current_song':
      return <SongSlide data={dataPoints} />;
    case 'skills_completed_since_last_roundup':
      return <RecentSkillsSlide data={dataPoints} />;
    case 'skills_in_progress':
      return <SkillsInProgressSlide data={dataPoints} />;
    case 'skills_upcoming':
      return <UpcomingSkillsSlide data={dataPoints} />;
    case 'skills_completed':
      return <SkillsTotalSlide data={dataPoints} />;
    case 'trinity_grade':
      return (
        <TrinityGradeSlide
          data={dataPoints}
          triggerAudioTrackPause={triggerAudioTrackPause}
          isAndroid={isAndroid}
        />
      );
    case 'trinity_progress':
      return <TrinityProgressSlide data={dataPoints} />;
    case 'upcoming_concert':
      return <UpcomingConcertSlide data={dataPoints} />;
    case 'outro':
      return <OutroPosterSlide data={dataPoints} triggerClose={triggerClose} />;
    default:
      return null;
  }
};

const SlideManager = ({
  slides,
  kidId,
  grownUpId,
  index,
  startFunc,
  // visible,
  triggerAudioTrackPause,
  triggerClose,
  isAndroid
}) => {
  const transitions = useTransition(index, {
    keys: index,
    from: { opacity: 0, transform: 'translateX(100%)' },
    enter: { opacity: 1, transform: 'translateX(0%)' },
    leave: { opacity: 0, transform: 'translateX(-100%)' },
    config: { tension: 220, friction: 20 },
  });

  return (
    <div>
      {transitions((style, i) => (
        <animated.div key={i} style={{ ...style }}>
          {getSlideComponent(slides[i], {
            kidId,
            grownUpId,
            startFunc,
            triggerAudioTrackPause,
            triggerClose,
            isAndroid
          })}
        </animated.div>
      ))}
    </div>
  );
};

export default SlideManager;

const SlideProps = {
  colorOption: PropTypes.number,
  dataPoints: PropTypes.shape({
    date: PropTypes.string,
    instrument: PropTypes.string,
    kid_name: PropTypes.string,
    band_role: PropTypes.string,
    band_name: PropTypes.string
  }),
  name: PropTypes.string,
  order: PropTypes.number,
  tracking: PropTypes.string
};

SlideManager.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape(SlideProps)).isRequired,
  kidId: PropTypes.string.isRequired,
  grownUpId: PropTypes.string.isRequired,
  startFunc: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  // visible: PropTypes.bool.isRequired,
  triggerAudioTrackPause: PropTypes.func.isRequired,
  triggerClose: PropTypes.func.isRequired,
  isAndroid: PropTypes.bool
};


SlideManager.defaultProps = {
  isAndroid: false
}